import { LoginForm } from "@/components/login-form"
import { ConbersaLogo } from "@/components/ConbersaLogo"
import { PageTransition, StaggerChildren, MotionDiv, fadeInLeft, fadeInRight, bounceIn } from "@/components/ui/motion-components"

export default function LoginPage() {
	return (
		<PageTransition>
			<div className="grid min-h-svh lg:grid-cols-2">
				<StaggerChildren className="flex flex-col gap-4 p-6 md:p-10">
					<MotionDiv
						variants={fadeInLeft}
						className="flex justify-center gap-2 md:justify-start"
					>
						<a href="#" className="flex items-center gap-2 font-medium group">
							<MotionDiv
								variants={bounceIn}
								whileHover={{
									rotate: [0, -10, 10, -10, 0],
									scale: 1.1
								}}
								transition={{
									rotate: { duration: 0.5 },
									scale: { type: "spring", stiffness: 300 }
								}}
								className="flex items-center justify-center"
							>
								<ConbersaLogo size={24} className="drop-shadow-sm" />
							</MotionDiv>
							<MotionDiv
								whileHover={{ x: 5 }}
								transition={{ type: "spring", stiffness: 300 }}
							>
								Conbersa
							</MotionDiv>
						</a>
					</MotionDiv>
					<MotionDiv
						variants={fadeInLeft}
						className="flex flex-1 items-center justify-center"
					>
						<MotionDiv
							className="w-full max-w-xs"
							whileHover={{ scale: 1.02 }}
							transition={{ type: "spring", stiffness: 300 }}
						>
							<LoginForm />
						</MotionDiv>
					</MotionDiv>
				</StaggerChildren>
				<MotionDiv
					variants={fadeInRight}
					initial="initial"
					animate="animate"
					className="bg-muted relative hidden lg:block overflow-hidden"
				>
					{/* Animated background gradient */}
					<MotionDiv
						animate={{
							background: [
								"linear-gradient(45deg, hsl(var(--primary)/0.05), hsl(var(--secondary)/0.05))",
								"linear-gradient(45deg, hsl(var(--secondary)/0.05), hsl(var(--accent)/0.05))",
								"linear-gradient(45deg, hsl(var(--accent)/0.05), hsl(var(--primary)/0.05))"
							]
						}}
						transition={{
							duration: 8,
							repeat: Infinity,
							ease: "linear"
						}}
						className="absolute inset-0"
					/>
					{/* Floating particles */}
					{[...Array(6)].map((_, i) => (
						<MotionDiv
							key={i}
							className="absolute w-2 h-2 bg-primary/20 rounded-full"
							animate={{
								x: [0, 100, 0],
								y: [0, -100, 0],
								opacity: [0, 1, 0]
							}}
							transition={{
								duration: 4 + i,
								repeat: Infinity,
								delay: i * 0.5,
								ease: "easeInOut"
							}}
							style={{
								left: `${20 + i * 15}%`,
								top: `${30 + i * 10}%`
							}}
						/>
					))}
				</MotionDiv>
			</div>
		</PageTransition>
	)
} 